import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkDialog from "../../components/atoms/TkDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_FAC007_Response, IAPI_FAC008_Request } from "../../type/apiType";
import "./_style.scss";
import { httpIAPI_FAC007, httpIAPI_FAC008 } from "./api/request";
import { fakeTableList, schema, schemaTwo } from "./parts";
import { CheckedList } from "../../type/apiType/IAPI_FAC008";
import _ from "lodash";
import { toNumberOrUndefined } from "../../utils/useTools";
/**
 * SCRC050029 措置入所障害児職員数、特定職員数の見込数変更申請
 * @return SCRC050029 措置入所障害児職員数、特定職員数の見込数変更申請
 */
const SCRC050029 = (): JSX.Element => {
  const navigate = useNavigate();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  // 持回情報
  const { state, setState } = useContext(GlobalContext);
  // 認証情報
  const { state: businessState } = useContext(BusinessContext);
  // スキーマルール
  const [schemaRule, setSchemaRule] = useState<any>(schema);

  // ユーザタイプ
  const userType = state.authInfo?.userType;
  // 被共済職員でなくなった理由、被共済職員でなくなった年月日の活性状態
  const [responseData, setResponseData] = useState<IAPI_FAC007_Response>();
  // 措置入所障害児関係業務従事職員数
  const [aHcStaffNumInput, setAHcStaffNumInput] = useState<number>(0);
  // 特定職員数
  const [aSpecificStaffNumInput, setASpecificStaffNumInput] =
    useState<number>(0);
  // 選択中の施設
  const [currentFacility, setCurrentFacility] = useState<string>();
  // 年度
  const [year, setYear] = useState<string>();
  // 訂正する項目を選択
  const [selectedFixColumn, setSelectedFixColumn] = useState<string>("1");

  // チェック済みリスト
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);

  // 登録確認ダイアログ表示
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

  // API-FAC008 POSTデータ
  const fac008PostDataRef = useRef<any>(null);

  // 訂正項目の変更
  useEffect(() => {
    if (selectedFixColumn === "1") {
      setSchemaRule(schema);
    } else {
      setSchemaRule(schemaTwo);
    }
  }, [selectedFixColumn]);

  // 措置入所障害児関係業務従事職員数の変更
  useEffect(() => {
    if (aHcStaffNumInput) {
      let resArr = stateFakeTableList.current;
      const selectedFacility = responseData?.facilityList?.find(
        (data) => data.facilityNo === currentFacility
      );
      if (selectedFacility) {
        let aHcStaffNum = resArr.find(
          (item) => item.keyword === "aHcStaffNum"
        )!;
        const isLessStaffNum =
          (selectedFacility.bHcStaffNum ?? 0) > aHcStaffNumInput;
        if (isLessStaffNum) {
          aHcStaffNum.outerTextRight =
            "職員数が減少する場合は掛金が減少する恐れがあります。";
        } else {
          aHcStaffNum.outerTextRight = "";
        }
      }
      setStateInfoList([...resArr]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aHcStaffNumInput]);

  // 特定職員数の変更
  useEffect(() => {
    if (aSpecificStaffNumInput) {
      let resArr = stateFakeTableList.current;
      const selectedFacility = responseData?.facilityList?.find(
        (data) => data.facilityNo === currentFacility
      );
      if (selectedFacility) {
        let aSpecificStaffNum = resArr.find(
          (item) => item.keyword === "aSpecificStaffNum"
        )!;
        const isLessStaffNum =
          (selectedFacility.bSpecificStaffNum ?? 0) > aSpecificStaffNumInput;
        if (isLessStaffNum) {
          aSpecificStaffNum.outerTextRight =
            "職員数が減少する場合は掛金が減少する恐れがあります。";
        } else {
          aSpecificStaffNum.outerTextRight = "";
        }
      }
      setStateInfoList([...resArr]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aSpecificStaffNumInput]);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let fixColumn = resArr.find((item) => item.keyword === "fixColumn")!;
    let bHcStaffNum = resArr.find((item) => item.keyword === "bHcStaffNum")!;
    let bSpecificStaffNum = resArr.find(
      (item) => item.keyword === "bSpecificStaffNum"
    )!;
    let aHcStaffNum = resArr.find((item) => item.keyword === "aHcStaffNum")!;
    let aSpecificStaffNum = resArr.find(
      (item) => item.keyword === "aSpecificStaffNum"
    )!;
    let remark = resArr.find((item) => item.keyword === "remark")!;
    // 変更後の施設が未選択の場合
    if (!currentFacility || currentFacility === "" || currentFacility === "0") {
      // 「訂正する項目を選択」ラジオボタンの選択をクリアし、非活性にする
      fixColumn.setDefaultValue = "";
      // 他項目の値をクリアして、再描画を行う
      bHcStaffNum.text = null;
      bSpecificStaffNum.text = null;
      aHcStaffNum.setDefaultValue = null;
      aSpecificStaffNum.setDefaultValue = null;
      remark.setDefaultValue = "";
    } else {
      const selectedFacilityInfo = responseData?.facilityList?.find(
        (item) => item.facilityNo === currentFacility
      )!;
      // 特定職員数対象フラグが"1"（対象）の場合
      if (selectedFacilityInfo.specificStaffNumFlg === "1") {
        fixColumn.setDefaultValue = "2";
        bSpecificStaffNum.text =
          (selectedFacilityInfo.bSpecificStaffNum ?? "") + "人";
        bSpecificStaffNum.showLine = true;
        aSpecificStaffNum.showLine = true;
        bHcStaffNum.showLine = false;
        aHcStaffNum.showLine = false;
        aSpecificStaffNum.setDefaultValue = "";
        setSelectedFixColumn("2");
      } else {
        // 措置入所障害児関係業務従事職員数対象フラグが"1"（対象）の場合
        fixColumn.setDefaultValue = "1";
        bHcStaffNum.text = (selectedFacilityInfo.bHcStaffNum ?? "") + "人";
        bHcStaffNum.showLine = true;
        aHcStaffNum.showLine = true;
        bSpecificStaffNum.showLine = false;
        aSpecificStaffNum.showLine = false;
        aHcStaffNum.setDefaultValue = "";
        setSelectedFixColumn("1");
      }
      // 備考の値を設定する。
      remark.setDefaultValue = "";
      setYear((state.authInfo?.fiscalYear ?? 0).toString());
    }
    setStateInfoList([...resArr]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFacility]);

  // 初期表示
  const handleInit = async () => {
    try {
      // 職員詳細情報参照API呼び出し
      const res = await httpIAPI_FAC007({
        contractorNo:
          userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo, //共済契約者番号
      });
      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        //施設を選択
        let facilityName = resArr.find(
          (item) => item.keyword === "facilityName"
        )!;
        // 訂正する項目を選択
        let fixColumn = resArr.find((item) => item.keyword === "fixColumn")!;
        // 措置入所障害児関係業務従事職員数（見込数）
        let bHcStaffNum = resArr.find(
          (item) => item.keyword === "bHcStaffNum"
        )!;
        // 特定職員数（見込数）
        let bSpecificStaffNum = resArr.find(
          (item) => item.keyword === "bSpecificStaffNum"
        )!;
        // 措置入所障害児関係業務従事職員数
        let aHcStaffNum = resArr.find(
          (item) => item.keyword === "aHcStaffNum"
        )!;
        let aSpecificStaffNum = resArr.find(
          (item) => item.keyword === "aSpecificStaffNum"
        )!;
        // 備考
        let remark = resArr.find((item) => item.keyword === "remark")!;
        aHcStaffNum.onGetInputValue = (event: any) => {
          setAHcStaffNumInput(event.target?.value);
        };
        aSpecificStaffNum.onGetInputValue = (event: any) => {
          setASpecificStaffNumInput(event.target?.value);
        };

        fixColumn.setDefaultValue = "1";
        fixColumn.disabled = true;
        bHcStaffNum.showLine = true;
        bHcStaffNum.text = null;
        bSpecificStaffNum.showLine = false;
        bSpecificStaffNum.text = null;
        aHcStaffNum.setDefaultValue = null;
        aHcStaffNum.outerTextRight = "";
        aSpecificStaffNum.setDefaultValue = null;
        aSpecificStaffNum.outerTextRight = "";
        remark.setDefaultValue = "";
        let facilityNameSelectList: { value: string; label: string }[] = [];
        (res?.facilityList ?? []).forEach((facility: any) => {
          facilityNameSelectList.push({
            value: facility.facilityNo,
            label:
              (facility.facilityNo ?? "") + ":" + (facility.facilityName ?? ""),
          });
        });

        facilityName.selectPropsList = facilityNameSelectList;
        facilityName.onGetValue = (value: string) => {
          facilityName.setDefaultValue = value;
          setCurrentFacility(value);
        };
        facilityName.setDefaultValue = "";
        setStateInfoList(resArr);
        setResponseData(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      // エラー内容を表示する。
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (obj: any): IAPI_FAC008_Request => {
    const selectedFacility = responseData?.facilityList?.find(
      (data) => data.facilityNo === currentFacility
    );
    const reqObj: IAPI_FAC008_Request = {
      contractorNo:
        userType === authorityUserType.userTypeNumber.KIKO
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo, //共済契約者番号
      year: toNumberOrUndefined(year), // 年度
      facilityNo: currentFacility, // 施設番号
      bSpecificStaffNum:
        selectedFixColumn === "2"
          ? selectedFacility?.bSpecificStaffNum
          : undefined, // 変更前/特定職員数（見込数）
      aSpecificStaffNum:
        selectedFixColumn === "2" ? obj.aSpecificStaffNum : undefined, // 変更後/特定職員数）
      bHcStaffNum:
        selectedFixColumn === "1" ? selectedFacility?.bHcStaffNum : undefined, // 変更前/措置入所障害児関係業務従事職員数（見込数）
      aHcStaffNum: selectedFixColumn === "1" ? obj.aHcStaffNum : undefined, // 変更後/措置入所障害児関係業務従事職員数
      remark: obj.remark, // 備考
      checkedList: checkedList,
    };
    return reqObj;
  };

  const onSave = async () => {
    try {
      // 職員情報詳細更新API呼び出し
      const res = (await httpIAPI_FAC008({
        ...makeHttpObj(fac008PostDataRef.current),
      })) as { [key: string]: any };

      setCheckedList(res.checkedList || []);
      // 確認ダイアログを消す
      setOpenConfirmDialog(false);

      if (res.resultCd === "I0000") {
        setCheckedList([]);
        // 自画面再描画
        setStateInfoList([]);
        setCurrentFacility("");
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC050029" data-testid="SCRC050029PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050029_01}</TkInfoManual>
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schemaRule}
        onCheckAndSubmit={(data) => {
          fac008PostDataRef.current = data;
          setOpenConfirmDialog(true);
          setState({
            ...state,
            errorMsgId: "",
          });
        }}
        buttonGroup={
          <Box className="btn">
            <TkBackButton></TkBackButton>
          </Box>
        }
        submitButtonText="登録"
      />
      <TkDialog
        open={openConfirmDialog}
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
        onSave={onSave}
        onCancel={() => setOpenConfirmDialog(false)}
      />
    </Box>
  );
};

export default SCRC050029;
